import axios from 'lib/axios';

const createEvent = async (value) => {
  const { data } = await axios.post('/admin/event', value);
  return data;
};

const getAllEvents = async (dId) => {
  const { data } = await axios.get(`/admin/event?divisionId=${dId || ''}`);
  return data;
};

const getEventById = async (id) => {
  const { data } = await axios.get(`/admin/event/${id}`);
  return data;
};

const updateEvent = async (value) => {
  const { eventId, newEvent } = value;
  const { data } = await axios.put(`/admin/event/${eventId}`, newEvent);
  return data;
};

export { createEvent, getAllEvents, getEventById, updateEvent };
